export default "__VITE_ASSET__CN7xWgtr__"